import Layout from '@/features/layout';
import Container from '@/ui/container';
import { SignIn } from '@clerk/nextjs';
import { getAuth } from '@clerk/nextjs/server';

export default function LoginPage() {
	return (
		<Layout>
			<Container>
				<main className="flex flex-col justify-center items-center mx-4 mt-4">
					<SignIn
						appearance={{
							elements: {
								formButtonPrimary: 'bg-[#10B981]',
								formFieldInput:
									'focus:ring-emerald-300 focus:border-emerald-300',
								footer: 'hidden'
							}
						}}
						path="/login"
						routing="path"
						fallbackRedirectUrl="/dashboard/families"
					/>
				</main>
			</Container>
		</Layout>
	);
}

export async function getServerSideProps(context) {
	const { userId } = getAuth(context.req);

	// Redirect to dashboard if already authenticated
	if (userId) {
		return {
			redirect: {
				destination: '/dashboard/families',
				permanent: false
			}
		};
	}

	return {
		props: {}
	};
}
